import {
  Investment,
  useInvestmentPerformance,
  useTradingGainForInvestment,
} from "@rentablo/api/apiv1";

interface Params {
  investmentId: number;
  investment?: Investment;
  displayCurrency: string;
  isOriginal: boolean;
}

export const useInvestmentCurrencyView = ({
  investmentId,
  investment,
  displayCurrency,
  isOriginal,
}: Params) => {
  const realizedGainsQuery = useTradingGainForInvestment(
    { id: investmentId, displayCurrency },
    { enabled: investmentId !== undefined }
  );
  const investmentPerformanceQuery = useInvestmentPerformance(
    { id: investmentId, displayCurrency },
    { enabled: investmentId !== undefined }
  );

  const netGain = isOriginal
    ? (realizedGainsQuery.data?.accumulatedGain?.netGain ?? 0)
    : (realizedGainsQuery.data?.accumulatedGain?.netGainAC ?? 0);

  const returnOnInvestment = isOriginal
    ? (investment?.returnOnInvestment ?? 0)
    : (investment?.returnOnInvestmentAC ?? 0);

  const returnOnInvestmentInPercent = isOriginal
    ? (investment?.returnOnInvestmentInPercent ?? 0)
    : (investment?.returnOnInvestmentInPercentAC ?? 0);

  const performance =
    (isOriginal
      ? investmentPerformanceQuery.data?.inInvestmentCurrency
      : investmentPerformanceQuery.data?.inAccountCurrency
    )?.twrorWithDividends ?? 0;

  const gainAndLoss = netGain + returnOnInvestment;

  return {
    netGain,
    returnOnInvestment,
    returnOnInvestmentInPercent,
    performance,
    gainAndLoss,
  };
};
